import React from 'react';
import { FadeIn } from './FadeIn';
import { ButtonCTA } from './ButtonCTA';
import { BookOpen, List, Map, PartyPopper, Sparkles } from 'lucide-react';
export function Package() {
  const includes = [{
    icon: <BookOpen size={28} data-id="element-219" />,
    title: 'Manual premium completo',
    desc: 'Todo el sistema explicado paso a paso, sin tecnicismos ni complicaciones'
  }, {
    icon: <List size={28} data-id="element-220" />,
    title: '32 recetas sencillas',
    desc: 'Fáciles de preparar, con ingredientes reales y sabor que te va a sorprender'
  }, {
    icon: <Map size={28} data-id="element-221" />,
    title: 'Guía para comer fuera',
    desc: 'Qué pedir en restaurantes, qué evitar y cómo moverte sin perder el hilo'
  }, {
    icon: <PartyPopper size={28} data-id="element-222" />,
    title: 'Capítulo de fiestas y alcohol',
    desc: 'Estrategias para disfrutar eventos sociales sin culpa ni rebote'
  }, {
    icon: <Sparkles size={28} data-id="element-223" />,
    title: 'Sistema de sustitución inteligente',
    desc: 'El método central: cómo cambiar ingredientes clave sin perder sabor ni placer'
  }];
  return <section className="py-24 bg-warm-beige/40 border-b border-gray-100" data-id="element-224">
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-225">
        <FadeIn data-id="element-226">
          <div className="text-center mb-16" data-id="element-227">
            <h2 className="text-3xl md:text-5xl font-serif font-bold text-warm-brown mb-6" data-id="element-228">
              Qué Incluye
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto" data-id="element-229">
              Todo lo que necesitas para empezar a ver resultados sin
              complicarte la vida.
            </p>
          </div>
        </FadeIn>

        <div className="bg-white rounded-3xl shadow-xl overflow-hidden border border-warm-beige mb-12" data-id="element-230">
          <div className="p-6 sm:p-10 md:p-12" data-id="element-231">
            <div className="space-y-8" data-id="element-232">
              {includes.map((item, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-233">
                  <div className="flex items-start p-4 rounded-2xl hover:bg-warm-beige/20 transition-colors border border-transparent hover:border-warm-beige/50" data-id="element-234">
                    <div className="bg-olive-green/10 text-olive-green p-4 rounded-2xl mr-6 shrink-0" data-id="element-235">
                      {item.icon}
                    </div>
                    <div data-id="element-236">
                      <h3 className="text-xl font-bold text-gray-900 mb-2" data-id="element-237">
                        {item.title}
                      </h3>
                      <p className="text-gray-600 leading-relaxed" data-id="element-238">
                        {item.desc}
                      </p>
                    </div>
                  </div>
                </FadeIn>)}
            </div>
          </div>
        </div>

        <FadeIn delay={0.6} data-id="element-239">
          <div className="text-center" data-id="element-240">
            <ButtonCTA text="Quiero mi copia por $11.99" className="text-lg px-10 py-5" data-id="element-241" />
          </div>
        </FadeIn>
      </div>
    </section>;
}